<template>
	<div class="grid gap-4">
		<FormKit type="loanlinkCurrency" name="annualAmount" label="Jaarbedrag" />
		<FormKit type="loanlinkDate" name="endDate" label="Einddatum" />
	</div>
</template>
